import { useState } from 'react';
import { Popover, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
	FacebookShareButton,
	FacebookIcon,
	TwitterShareButton,
	TwitterIcon,
	EmailShareButton,
	EmailIcon,
	LinkedinShareButton,
	LinkedinIcon
} from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import LinkIcon from '@mui/icons-material/Link';
import { $lightGray } from 'styles/colors';
import { ReactComponent as ShareIcon } from 'assets/icons/share.svg';
import { handleShareButtonClickEvent } from 'actions/firebase';

const buttonSize = 30;

const styles = {
	main: {
		height: 'fit-content',
		width: 'fit-content',
		padding: 20,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gridColumnGap: 10
	},
	roundButtonContainer: {
		height: 35
	},
	roundButton: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		cursor: 'pointer',
		height: buttonSize,
		width: buttonSize,
		color: 'white',
		borderRadius: '50%',
		backgroundColor: $lightGray
	}
};
const ShareModal = ({ name, type }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const useStyles = makeStyles(styles);
	const classes = useStyles();

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = e => {
		e.preventDefault();
		setAnchorEl(null);
	};

	let title;
	let hashtag;

	switch (type) {
		case 'notify-and-fly':
			title = "There's a new active #NotifyAndFly flight plan filed. See the details on #AirAware.";
			hashtag = '#NotifyAndFly';
			break;
		default:
			title = `#AirAware, check out this airspace advisory: ${name} (${type})`;
			hashtag = '#AirAware';
			break;
	}

	const url = window.location.href;

	return (
		<div>
			<IconButton variant='contained' color='primary' onClick={handleClick} size='large'>
				<ShareIcon />
			</IconButton>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
			>
				<div className={classes.main} onClick={handleClose}>
					<TwitterShareButton title={title} url={url}>
						<TwitterIcon
							round
							size={buttonSize}
							onClick={() => handleShareButtonClickEvent('twitter')}
						/>
					</TwitterShareButton>
					<FacebookShareButton hashtag={hashtag} url={url}>
						<FacebookIcon
							round
							size={buttonSize}
							onClick={() => handleShareButtonClickEvent('facebook')}
						/>
					</FacebookShareButton>
					<LinkedinShareButton title={title} summary={title} url={url}>
						<LinkedinIcon
							round
							size={buttonSize}
							onClick={() => handleShareButtonClickEvent('linkedin')}
						/>
					</LinkedinShareButton>
					<EmailShareButton subject={title} body={title} separator={' | Link: '} url={url}>
						<EmailIcon
							round
							size={buttonSize}
							onClick={() => handleShareButtonClickEvent('email')}
						/>
					</EmailShareButton>
					<CopyToClipboard text={url}>
						<div className={classes.roundButtonContainer}>
							<div className={classes.roundButton}>
								<LinkIcon fontSize='small' onClick={() => handleShareButtonClickEvent('link')} />
							</div>
						</div>
					</CopyToClipboard>
				</div>
			</Popover>
		</div>
	);
};

export default ShareModal;
